// extracted by mini-css-extract-plugin
module.exports = {"slide":"HistoryNote_slide_Ev4CE","slide-reverse":"HistoryNote_slide-reverse_3OcQz"};